export enum TargetAudience {
  All = 1,
  InvestorOnly = 2,
}